import { getRunVUChartDataObject, getVUChartFilterObject } from '../../VisualunitHelpers'
import { chartFilter } from '../Reports/ReportFrame'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { useZustandVisualUnitStore } from '../Reports/vuContext'

interface FilterListProp {
    visualUnitId: number
    explore: string
    chartFilter: chartFilter
}

export const FilterList = (props: FilterListProp) => {
    const { visualUnitId, explore, chartFilter } = { ...props }
    const totalDisplayString = 'Aggregate'

    const updateChartFilters = useZustandVisualUnitStore((s) => s.updateChartFilters);

    const filterVisualUnitChart = (metaDataId: number, newFilterValue: string) => {
        const isExplore = explore === 'yes' ? true : false
        const filterObj = getVUChartFilterObject()
        filterObj.metaDataId = metaDataId
        filterObj.filterValue = newFilterValue
        updateChartFilters([filterObj])
    }

    return (
        <>
            <div className="filter-name">
                Filter by {chartFilter.filterVUDetail.MetaData.FieldName}
            </div>
            <ul id={`vu_chart_filter_list_${visualUnitId}`} className="filter-list">
                {chartFilter.rawValueList.map((fiRawValue, index) => (
                    <li
                        className={
                            fiRawValue === chartFilter.rawValue
                                ? 'filter-list-item-active'
                                : 'filter-list-item'
                        }
                        onClick={() =>
                            filterVisualUnitChart(chartFilter.filterVUDetail.MetaDataId, fiRawValue)
                        }
                    >
                        {chartFilter.displayValueList[index]}
                    </li>
                ))}
                <li
                    className={
                        chartFilter.rawValue === 'Aggregate'
                            ? 'filter-list-item-active'
                            : 'filter-list-item'
                    }
                    onClick={() =>
                        filterVisualUnitChart(
                            chartFilter.filterVUDetail.MetaDataId,
                            totalDisplayString
                        )
                    }
                >
                    {totalDisplayString}
                </li>
            </ul>
        </>
    )
}

export default FilterList
